import { Component, OnInit, ViewChild} from '@angular/core';

import { AppMemoryService } from './../../core/app-memory.service';
import { GetService } from '../../core/get.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.less']
})
export class ContactComponent implements OnInit {

  @ViewChild('createFeedback')
  public createFeedback: any;

  public serverError = null;
  public isRequestInProgress: boolean = false;
  public isRequestSuccess: boolean = false;

  public feedback = {
    subject: '' as string,
    text: '' as string
  }

  public translation = {};

  constructor(
    public appMemory: AppMemoryService,
    public getService: GetService,
    public translateService: TranslateService
  ) {
    this.getTranslation();
   }

  ngOnInit() {
  }


  sendFeedback(form: any) {
    this.serverError = null;
    this.isRequestSuccess = false;

    if(form.form.invalid) {
      console.log('Form invalid!');
      return;
    }

    this.isRequestInProgress = true;
    this.getService.sendFeedback(this.feedback).then((res: any) => {
      this.isRequestInProgress = false;
      this.isRequestSuccess = true;
      this.clearUserInput(form);
    }, (err:any) => {
      if (err.status === 500) {
        this.serverError = [this.translation['errorOccurred']];
      } else {
        this.serverError = this.objectToArray( JSON.parse(err._body) );
      }
      this.isRequestInProgress = false;
      this.isRequestSuccess = false;
    })
  }

  public objectToArray(obj: Object) {
    return Object.keys(obj).map(key => obj[key]); // transorm Array-like Object to Array
  }

  clearUserInput(form: any) {
    this.serverError = null;
    form.resetForm();

    $('#feedback-subject-box').removeClass('input--filled');
    $('#feedback-text-box').removeClass('input--filled');

    this.feedback.subject = '';
    this.feedback.text = '';
  }

  getTranslation() {
    this.translateService.get('TREATS.errorOccurred').subscribe((word: string) => {
      this.translation['errorOccurred'] = word;
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/contact/contact.component.ts